import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getStudentScope = ({ version = 'v1', studentScopeId }) =>
  client
    .request({
      url: `${version}/k12-users/student-scope/${studentScopeId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentScopes = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/k12-users/student-scope/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createStudentScopeObject = ({
  version = 'v1',
  payload,
  params,
} = {}) =>
  client
    .request({
      url: `${version}/k12-users/student-scope/`,
      method: RequestMethod.POST,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteStudentScopeObject = ({ id, version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/k12-users/student-scope/${id}/`,
      method: RequestMethod.DELETE,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateStudentScopeObject = ({
  id,
  params,
  payload,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/k12-users/student-scope/${id}`,
      method: RequestMethod.PATCH,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const retrieveStudents = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/k12-users/student/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const retrieveGuardians = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/k12-users/guardians/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentSchools = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/k12-users/student-school/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentTags = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/roster/student-tags/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentHash = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/k12-users/student/student-hash/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentCaseloads = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/k12-users/student-caseload/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentCohortYears = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/k12-users/student-cohort-year/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentGradeYear = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/k12-users/student-grade-year/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStaffTitles = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/k12-users/staff-titles/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const bulkUpdateStaffTitles = ({ version = 'v1', params, payload }) =>
  client
    .request({
      url: `${version}/k12-users/staff-titles/bulk-update/`,
      method: RequestMethod.POST,
      params,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentContext = ({ version = 'v1', params, studentId }) =>
  client
    .request({
      url: `${version}/k12-users/student/${studentId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
